module.exports = __webpack_public_path__ + "static/width-height-info-8459ce526e9b5f7fedc98946a266c65a.svg";